// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { ThematicDossierInfoResponseDTO } from "../../api/backend-openapi";
import {
  deleteThematicDossier,
  setThematicDossiers,
  updateThematicDossier
} from "./ThematicDossierEvents";

export const ThematicDossierStore = createStore<
  ThematicDossierInfoResponseDTO[]
>([])
  .on<ThematicDossierInfoResponseDTO[]>(
    setThematicDossiers,
    (
      state: ThematicDossierInfoResponseDTO[],
      payload: ThematicDossierInfoResponseDTO[]
    ) => payload
  )
  .on<string>(
    deleteThematicDossier,
    (state: ThematicDossierInfoResponseDTO[], payload: string) =>
      state.filter(thematicDossier => thematicDossier.id !== payload)
  )
  .on<ThematicDossierInfoResponseDTO>(
    updateThematicDossier,
    (
      state: ThematicDossierInfoResponseDTO[],
      payload: ThematicDossierInfoResponseDTO
    ) => {
      const index = state.findIndex(
        thematicDossier => thematicDossier.id === payload.id
      );
      state[index] = payload;
      return [...state];
    }
  );
